import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    dialogWidth: {
      width: "100%"
    },
    denominationsButton: {
      marginLeft: "5px",
      color: "goldenrod",
      border: "2px solid gray",
      backgroundColor: "transparent",
      marginTop: "5px",
      borderRadius: "5px",
      cursor: "pointer"
    },
    denominationsButtonError: {
      marginLeft: "5px",
      color: "goldenrod",
      border: "1px solid red",
      backgroundColor: "transparent",
      marginTop: "5px",
      borderRadius: "5px",
      cursor: "pointer"
    },
    denominationsContainer: {
      width: "90%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    titleBar: {
      textAlign: "start",
      backgroundColor: "#869ac4"
    },
    tableHeaders: {
      display: "flex",
      flexDirection: "row",
      width: "60%",
      alignSelf: "center",
      borderBottom: "1px solid gray",
      paddingBottom: "5px",
      marginBottom: "5px"
    },
    tableHeader: {
      width: "33.33%",
      textAlign: "center",
      fontSize: "0.9rem",
      fontWeight: "bold",
      color: "darkblue"
    },
    inputContainer: {
      display: "flex",
      flexDirection: "row",
      width: "60%",
      alignSelf: "center"
    },
    input: {
      width: "33.33%",
      textAlign: "center",
      fontSize: "0.9rem",
      marginTop: "3px",
      color: "darkblue"
    },
    inputWidth: {},
    summaryContainer: {
      display: "flex",
      border: "1px solid gray",
      flexDirection: "column",
      marginTop: "20px",
      width: "70%"
    },
    summaryItemContainer: {
      display: "flex",
      flexDirection: "row"
    },
    summaryTitle: {
      textAlign: "start",
      fontSize: "0.9rem",
      width: "50%",
      padding: "5px"
    },
    summaryValue: {
      textAlign: "end",
      fontSize: "0.9rem",
      width: "50%",
      padding: "5px",
      color: "darkblue"
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff"
    }
  })
);
